import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home";
import Contactanos from "../views/Contactanos";
import NuestroServicios from "../components/nuestroServicios";
import ProveedoresGuatemala from "../components/proveedoresGuatemala";
import ProveedoresElSalvador from "../components/proveedoresElSalvador";
import ProveedoresCostaRica from "../components/proveedoresCostaRica";
import ProveedoresHonduras from "../components/proveedoresHonduras";
import ProveedoresNicaragua from "../components/proveedoresNicaragua";
import ProveedoresPanama from "../components/proveedoresPanama";
import OtrosServicios from "../components/otrosServicios";
import EncuestaEvaluacion from "../components/EncuestaEvaluacion";
import EncuestaCierre from "../components/EncuestaCierre";
import Seguimiento from "../components/Seguimiento";
import DemoAsistencias from "../components/DemoAsistencia";
import PoliticasDePrivacidad from "../components/PoliticasDePrivacidad";
import Login from "../components/Login"
import AssaAsistencias from "../components/AssaAsistencias";
import MapaCoordenadas from "../components/MapaCoordenadas";
import SeguimientoAssa from "../components/SeguimientoAssa";
import TicketGrabacion from "../components/TicketGrabacion";
import TicketInformacion from "../components/TicketInformacion";
import SolicitudGrabaciones from "../components/TablaGrabaciones";
import SolicitudInformacion from "../components/TablaInformacion";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/demoAsistencias",
    name: "DemoAsistencias",
    component: DemoAsistencias,
  },
  {
    path: "/contactanos",
    name: "Contactanos",
    component: Contactanos,
  },
  {
    path: "/nuestroServicios",
    name: "NuestroServicios",
    component: NuestroServicios,
  },
  {
    path: "/proveedoresGuatemala",
    name: "ProveedoresGuatemala",
    component: ProveedoresGuatemala,
  },
  {
    path: "/proveedoresElSalvador",
    name: "ProveedoresElSalvador",
    component: ProveedoresElSalvador,
  },
  {
    path: "/proveedoresCostaRica",
    name: "ProveedoresCostaRica",
    component: ProveedoresCostaRica,
  },
  {
    path: "/proveedoresHonduras",
    name: "ProveedoresHonduras",
    component: ProveedoresHonduras,
  },
  {
    path: "/proveedoresNicaragua",
    name: "ProveedoresNicaragua",
    component: ProveedoresNicaragua,
  },
  {
    path: "/proveedoresPanama",
    name: "ProveedoresPanama",
    component: ProveedoresPanama,
  },
  {
    path: "/otrosServicios",
    name: "OtrosServicios",
    component: OtrosServicios,
  },
  {
    path: "/encuestaEvaluacion/:id",
    name: "EncuestaEvaluacion",
    component: EncuestaEvaluacion,
  },
  {
    path: "/encuestaCierre/:id",
    name: "encuestaCierre",
    component: EncuestaCierre,
  },
  {
    path: "/seguimiento/:id",
    name: "seguimiento",
    component: Seguimiento,
  },
  {
    path: "/politicas-de-privacidad",
    name: "politicas-de-privacidad",
    component: PoliticasDePrivacidad,
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/assaAsistencias",
    name: "AssaAsistencias",
    component: AssaAsistencias,
  },
  {
    path: "/mapaCoordenadas/:id",
    name: "MapaCoordenadas",
    component: MapaCoordenadas,
  },
  {
    path: "/seguimientoAssa/:id",
    name: "SeguimientoAssa",
    component: SeguimientoAssa,
  },
  {
    path: "/TicketGrabacion",
    name: "TicketGrabacion",
    component: TicketGrabacion,
  },
  {
    path: "/TicketInformacion",
    name: "TicketInformacion",
    component: TicketInformacion,
  },
  {
    path: "/SolicitudGrabaciones",
    name: "SolicitudGrabaciones",
    component: SolicitudGrabaciones,
  },
  {
    path: "/SolicitudInformacion",
    name: "SolicitudInformacion",
    component: SolicitudInformacion,
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
